import React, { useMemo, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';

export default function VerifyEmailSent() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const email = useMemo(() => String(searchParams.get('email') || '').trim(), [searchParams]);

  const initialMessage = String(location.state?.message || '').trim();
  const initialSent = location.state?.verificationEmailSent;
  const initialDevLink = String(location.state?.devVerificationLink || '').trim();

  const [status, setStatus] = useState(initialMessage);
  const [loading, setLoading] = useState(false);
  const [devVerificationLink, setDevVerificationLink] = useState(initialDevLink);

  const canResend = Boolean(email) && !loading;

  const resend = async () => {
    if (!email) {
      setStatus('Missing email. Go back and enter your email, then register again.');
      return;
    }

    setLoading(true);
    setStatus('');
    try {
      const res = await authAPI.resendVerification(email);
      setStatus(String(res?.data?.message || 'Verification email sent.'));
      setDevVerificationLink(String(res?.data?.devVerificationLink || '').trim());
    } catch (err) {
      setStatus(String(err?.response?.data?.error || err?.message || 'Failed to resend verification email.'));
    } finally {
      setLoading(false);
    }
  };

  const header = initialSent === false
    ? 'Account created (email not delivered yet)'
    : 'Check your email to verify your account';

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{header}</h2>

        <div className="success-message" style={{ marginBottom: 12 }}>
          {email ? (
            <>
              We sent a verification link to <strong>{email}</strong>. Open it to activate your account.
            </>
          ) : (
            'We sent a verification link to your email. Open it to activate your account.'
          )}
        </div>

        <div className="success-message" style={{ marginBottom: 12 }}>
          Tip: check Spam/Promotions. If you used a wrong email, register again with the correct one.
        </div>

        {status && <div className="success-message">{status}</div>}

        {devVerificationLink && (
          <div className="success-message">
            Local verification link: <a href={devVerificationLink}>{devVerificationLink}</a>
          </div>
        )}

        <div className="resend-verification-row" style={{ marginTop: 12 }}>
          <button type="button" onClick={resend} disabled={!canResend}>
            {loading ? 'Resending...' : 'Resend verification email'}
          </button>
        </div>

        <p style={{ marginTop: 14 }}>
          <Link to="/login">Go to login</Link>
        </p>
      </div>
    </div>
  );
}

